export default __webpack_public_path__ + "static/media/Group517@2x.6d8cd776.png";